import styled from 'styled-components';
import Image from 'gatsby-theme-core/src/components/image';

export default styled(Image)`
  aspect-ratio: 16 / 9;
  object-fit: cover;
`;
